import React, { Component } from "react";
import { Button, View, Text } from "react-native";
import {isWeb, navigate} from "../../helpers/utils.js";
import AppConfig from "../../config/AppConfig";
import NativeHelper from "../v3/native/NativeHelper";

if (window.CefSharp) {
  window.CefSharp.DeleteBoundObject("embeddedLogin");
  window.CefSharp.RemoveObjectFromCache("embeddedLogin");
  window.CefSharp.BindObjectAsync("embeddedLogin");
}


class PageLogin extends Component {
  constructor(props) {
    super(props);

    const controller = props.controller;
    this.controller = controller;

    this.credentials = require("../../config/auth0-web-credentials");
    this.credentials.redirectUri = window.location.origin;
    this.credentials.scope = "openid profile email";
    if (this.credentials.redirectUri === "file://")
      this.credentials.redirectUri = "file:///callback";

    const auth = require("auth0-web");
    this.auth0 = new auth.default(this.credentials);
  }

  doLogin = (auth0) => {
    if (window.embeddedLogin && window.embeddedLogin.login) {
      window.embeddedLogin.login();
      if (window.embeddedLogin.os && window.embeddedLogin.os() == "windows") {
        console.log("Pending login...");
        if (this.hasNavigation()) {
          this.props.navigation.navigate("pending_login");
        } else {
          navigate(this.controller, "pending_login");
        }
      }
    } else {
      auth0.signIn();
    }
  };

  parse() {
    const auth0 = this.auth0;
    const controller = this.props.controller;
    const loginSucceedeed = this.loginSucceedeed.bind(this);
    const loginFailed = this.loginFailed.bind(this);
    const currentScreen = controller.state.currentScreen;
    const hasNavigation = this.hasNavigation.bind(this);
    const doLogin = this.doLogin.bind(this);

    if (controller.state.installId == null) {
      console.log("Parse login, null install, restore state");
      controller.restoreState();
    }

    if (this.controller.state.currentUser == null) {
      if (window.location.hash == null) {
        doLogin(auth0);
      } else {
        auth0.parseHash().then(
          function (result) {
            if (
              auth0.isAuthenticated() &&
              (hasNavigation() ||
                currentScreen === "welcome" ||
                currentScreen === "login")
            ) {
              loginSucceedeed(
                auth0.getProfile().email,
                auth0.getAccessToken(),
                auth0.getProfile().picture,
              );
            } else if (
              hasNavigation() ||
              (!auth0.isAuthenticated() && currentScreen === "login")
            ) {
              doLogin(auth0);
            }
          },
          function (err) {
            if (err == null) {
              if (hasNavigation()) {
                const navigation =
                  this.props.navigation || this.controller.navigation;
                navigation.navigate(this.getMainPage());
              } else {
                navigate(this.controller, "rn:home_card");
              }
            } else if (window.location.hash == "") {
              onLogin();
            } else {
              loginFailed(err);
            }
          },
        );
      }
    } else {
      if (hasNavigation()) {
        this.props.navigation.navigate(this.getMainPage());
      } else {
        navigate(this.controller, "rn:home_card");
      }
    }
  }

  getMainPage() {
    let target = "mana";
    const termsAgreed =
      this.controller.state.settings != null &&
      this.controller.state.settings.terms_agreed;
    if (
      this.controller.state.settings != null &&
      AppConfig.USE_NAVIGATION &&
      !termsAgreed &&
      !["login", "welcome", "error"].includes(target)
    )
      target = "terms";
    return target;
  }

  componentDidMount() {
    this.parse();
  }

  render() {
    return (
      <View
        style={{ alignItems: "center", justifyContent: "center", flex: 1 }}
      />
    );
  }

  loginFailed(error) {
    console.log("Login failed: " + JSON.stringify(error));
    if (error != null && error.name !== "a0.state.invalid") {
      //TODO: rewrite auth0
    } else {
      if (this.hasNavigation()) {
        this.props.navigation.navigate("feed");
      } else {
        this.controller.changePage("feed");
      }
    }
  }

  loginSucceedeed(user, token, picture) {
    console.log("Logged in " + user + " " + token + " " + picture);
    this.sendLoginInfo({ user: user, token: token, picture: picture });
    this.controller.setState({
      currentUser: user,
      accessToken: token,
      picture: picture,
    });
    this.controller.refreshIntegrations(true);
    this.onNext();
  }

  sendLoginInfo(data) {
    this.controller.apiService.sendNotification("login", data);
  }

  onNext() {
    if (this.hasNavigation()) {
      const navigation = this.props.navigation || this.controller.navigation;
      navigation.navigate(this.getMainPage());
    } else {
      navigate(this.controller, "rn:home_card");
    }
  }

  onLogin() {
    if (this.hasNavigation()) {
      const navigation = this.props.navigation || this.controller.navigation;
      navigation.navigate("login");
    } else {
      this.controller.changePage("login");
    }
  }

  async auth0logout() {
    window.location.hash = "";
    console.log("Logged out");
    if (window.embeddedLogin && window.embeddedLogin.logout) {
      window.embeddedLogin.logout();
    } else {
      const redirect = window.location.origin + "/callback";
      this.auth0.signOut(redirect);
    }

    this.controller.resetState(false);
    this.controller.saveState(1).then((r) => {
      window.location.href = "/";
      //window.location.reload(true);
      //navigate(this.controller, "welcome", null, null);
    });
  }

  hasNavigation() {
    return this.controller
      ? this.controller.hasNavigation()
      : AppConfig.USE_NAVIGATION;
  }

  logout() {
    this.controller.logout();
    this.auth0logout();
  }
}

export default PageLogin;
